// Leaf module (no imports) so both IdleHandling (writer) and AuthHelper (reader) can share the
// "idle warning open" flag without creating an Auth <-> IdleHandling import cycle.
let warningActive = false;

export const setIdleWarningActive = (value) => {
  warningActive = !!value;
};

export const isIdleWarningActive = () => warningActive;
